export default function file(node) {
  const v = node.value
  return Array.isArray(v)
    ? !!v?.length
    : !!(v?.file || v?.fileUrl || v?.sortOrder)
}
